import React from "react";

import { helperService } from "../../services/helper.service";

import "./EventPills.scss";

// Shared event labels used by EventCard and the home feed. The look lives
// here; callers only position them.

const cx = (...parts: (string | undefined | false)[]) => parts.filter(Boolean).join(" ");

interface IStatusProps {
  status: string;
  isPastEvent?: boolean;
  className?: string;
}

export const EventStatusPill: React.FC<IStatusProps> = ({ status, isPastEvent, className }) => (
  <span className={cx("EventStatusPill", isPastEvent ? "finished" : (status || "").toLowerCase(), className)}>
    {isPastEvent ? "Finished" : helperService.getEventStatus(status)}
  </span>
);

interface IPillProps {
  children: React.ReactNode;
  className?: string;
}

export const LotteryPill: React.FC<IPillProps> = ({ children, className }) => (
  <span className={cx("LotteryPill", className)}>{children}</span>
);

export const SanctioningClubPill: React.FC<IPillProps> = ({ children, className }) => (
  <span className={cx("SanctioningClubPill", className)}>{children}</span>
);

interface IShowTypeProps extends IPillProps {
  as?: "li" | "span";
}

export const ShowTypePill: React.FC<IShowTypeProps> = ({ children, className, as = "span" }) => {
  const Tag = as;
  return <Tag className={cx("ShowTypePill", className)}>{children}</Tag>;
};
